import React from "react";
import { DifficultyPreset, GameState } from "../types/GameTypes";

interface GameControlsProps {
    gameState: GameState;
    isMiniMapVisible: boolean;
    difficultyPreset: DifficultyPreset;
    onTogglePause: () => void;
    onRestart: () => void;
    onChangeDifficulty: (difficulty: DifficultyPreset) => void;
    onToggleMiniMap: () => void;
}

export const GameControls: React.FC<GameControlsProps> = ({
    gameState,
    isMiniMapVisible,
    difficultyPreset,
    onTogglePause,
    onRestart,
    onChangeDifficulty,
    onToggleMiniMap,
}) => {
    const canPause = gameState === "playing" || gameState === "paused";

    return (
        <div className="pointer-events-none absolute bottom-3 right-3 z-30 flex flex-col items-end gap-2">
            <div className="pointer-events-auto inline-flex items-center gap-1 rounded-md border border-white/25 bg-black/45 px-1 py-1">
                {(["easy", "normal", "hard"] as const).map((preset) => {
                    const isActive = difficultyPreset === preset;
                    return (
                        <button
                            key={preset}
                            type="button"
                            className={`rounded px-2 py-1 text-[10px] font-semibold uppercase tracking-wide transition ${
                                isActive
                                    ? "bg-emerald-500/30 text-emerald-100"
                                    : "text-white/75 hover:bg-white/10 hover:text-white"
                            }`}
                            onClick={() => onChangeDifficulty(preset)}
                            aria-label={`Imposta difficolta ${preset}`}
                            aria-pressed={isActive}
                        >
                            {preset}
                        </button>
                    );
                })}
            </div>

            <div className="flex flex-wrap items-center justify-end gap-2">
                {canPause ? (
                    <button
                        type="button"
                        className="pointer-events-auto rounded-md border border-cyan-300/60 bg-cyan-500/15 px-2.5 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-cyan-100 transition hover:bg-cyan-500/25"
                        onClick={onTogglePause}
                        aria-label={gameState === "paused" ? "Riprendi partita" : "Metti in pausa"}
                    >
                        {gameState === "paused" ? "Riprendi" : "Pausa"}
                    </button>
                ) : null}

                <button
                    type="button"
                    className="pointer-events-auto rounded-md border border-amber-300/60 bg-amber-500/15 px-2.5 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-amber-100 transition hover:bg-amber-500/25"
                    onClick={onRestart}
                    aria-label="Ricomincia partita"
                >
                    Restart
                </button>

                <button
                    type="button"
                    className="pointer-events-auto rounded-md border border-slate-300/60 bg-slate-500/15 px-2.5 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-slate-100 transition hover:bg-slate-500/25"
                    onClick={onToggleMiniMap}
                    aria-label={isMiniMapVisible ? "Nascondi radar" : "Mostra radar"}
                >
                    {isMiniMapVisible ? "Radar Off" : "Radar On"}
                </button>
            </div>
        </div>
    );
};
